
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSideProps } from "next"
import Head from "next/head"
import { ParsedUrlQuery } from "querystring"

import getGroup from "@/graphql/requests/getGroup"
import SEO from "@/meta/SEO"
import Default from "@/templates/Default"
import Group from "@/ts/Group"
import GroupView from "@/views/group"

function GroupPage({ group }: { group: Group }) {
  const groupDescription = group?.description

  return (
    <>
      <Head>
        <title>{group?.name} | fansi.pl</title>
        <SEO description={groupDescription} />
      </Head>
      <GroupView group={group} />
    </>
  )
}

 const _getServerSideProps: GetServerSideProps = async ({ params }) => {
  const { slug } = params as Params
  const group = await getGroup(slug)

  if (!group) return { notFound: true }

  return {
    props: { group, slug },
  }
}

interface Params extends ParsedUrlQuery {
  slug: string
}

GroupPage.Layout = Default

export default GroupPage


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/groups/[slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  